// extracted by mini-css-extract-plugin
export default {"breakpoints":"0 480px 680px 960px 1120px 1280px 1440px","breakpointNames":"\"xxs\" \"xs\" \"s\" \"m\" \"l\" \"xl\" \"xxl\""};